module.exports = __webpack_public_path__ + "img/award_basis_softexpo_2023.fbd23c6e.jpg";